<template>
    <client-page>
        <v-container>
            <v-row>
                <v-col cols="12" md="4">
                    <v-img :src="author?.thumb?.url" :aspect-ratio="1 / 1" width="100%" :class="{ 'v-sheet--outlined': !author?.thumb?.url }">
                        <template #placeholder>
                            <v-overlay absolute dark color="transparent">
                                <v-icon color="grey" size="40">mdi-account</v-icon>
                            </v-overlay>
                        </template>
                    </v-img>
                </v-col>
                <v-col cols="12" md="">
                    <v-card flat tile class="primary--text">
                        <v-card-subtitle class="pa-0 font-weight-bold primary--text"> {{ author?.name?.en }} </v-card-subtitle>
                        <v-card-title class="px-0 py-30"> {{ author?.name?.ko }} </v-card-title>
                        <v-divider class="mb-20" />
                        <author-view-desc v-bind="{ author }" />
                        <v-divider class="mt-20" />
                        <v-card-text style="white-space: pre-line grey-68--text">
                            {{ author?.content }}
                        </v-card-text>
                    </v-card>
                    <!-- <v-card flat tile>
                        <v-card-subtitle> {{ author?.name?.en }} </v-card-subtitle>
                        <v-card-title> {{ author?.name?.ko }} </v-card-title>
                        <v-divider />
                        <author-view-desc v-bind="{ author }" />
                        <v-divider />
                        <v-card-text style="white-space: pre-line">
                            {{ author?.content }}
                        </v-card-text>
                    </v-card> -->
                </v-col>
            </v-row>

            <author-view-works v-bind="{ _author }" />

            <v-fade-transition leave-absolute>
                <v-overlay v-show="loading" color="white" light>
                    <v-progress-circular color="primary" indeterminate size="100" width="5" />
                </v-overlay>
            </v-fade-transition>
        </v-container>
    </client-page>
</template>

<script>
import api from "@/api";
import { initAuctionAuthor } from "@/assets/inits";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import AuthorViewDesc from "@/components/client/auction/authors/author-view-desc.vue";
import AuthorViewWorks from "@/components/client/auction/authors/author-view-works.vue";

export default {
    components: {
        ClientPage,
        AuthorViewDesc,
        AuthorViewWorks,
    },
    props: {
        _author: { type: String, default: null },
    },
    data: () => ({
        author: initAuctionAuthor(),
        works: [],

        loading: false,
    }),
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { _author } = this;
                const { author } = await api.v1.auction.authors.get({
                    _id: _author,
                });

                this.author = initAuctionAuthor(author);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.v-card__title {
    font-family: var(--font-notoserif);
    font-size: 2.4rem;
}
.v-card__text {
    padding: 32px 0 0;
}
@media (min-width:768px) {
    .v-card__title {
        font-size: 3.2rem;
    }
}
</style>